<template>
    <div class="control-container">
        <div class="m-1">

            <div class="container" style="margin-left: 15px; padding-left: 0px;">
                <div class="row">
                    <div class="col-1" style="padding-left: 0px; padding-right: 0px;">
                        <b-button v-b-toggle.collapse-1 variant="secondary" size="sm" >
                            <font-awesome-icon icon="cog" style="margin-right: 10px"/>
                            <font-awesome-icon icon="angle-down" />
                        </b-button>
                    </div>
                    <div class="col-10">
                        <div class="d-none d-md-block">
                            <!-- <font-awesome-icon icon="wave-square" style="margin-right: 12px" /> -->
                            <b-badge class="mr-1" pill variant="secondary" v-for="item in selectedMeasurements" :key="item.id">
                                {{item.label}}
                            </b-badge>
                        </div>

                        <div class="mt-2" style="font-size: small; font-weight: bold">
                           <!-- <font-awesome-icon icon="percentage" style="margin-right: 12px" /> -->
                            <span>Averaging Interval:</span> <span>{{selectedAverage}} seconds</span>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <b-collapse id="collapse-1" class="mt-2">
            <b-card bg-variant="light">
                <b-form-group
                        label-cols-lg="3"
                        label="Options"
                        label-size="lg"
                        label-class="font-weight-bold pt-0"
                        class="mb-0">
                    <b-form-group
                            label-cols-sm="3"
                            label="Average:"
                            label-align-sm="right"
                            label-for="nested-street">
                        <b-form-select v-model="selectedAverage" :options="averageOptions"></b-form-select>
                    </b-form-group>

                    <b-form-group
                            label-cols-sm="3"
                            label="Measurements:"
                            label-align-sm="right" class="mb-0">
                        <b-form-checkbox-group inline stacked
                                               v-model="selectedMeasurements"
                                               :options="measurementAvailableMeasurements"
                                               name="flavour-1a"></b-form-checkbox-group>
                    </b-form-group>
                </b-form-group>
            </b-card>
        </b-collapse>

    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: "MeasurementOptions",
        props: [],
        data() {
            return {
                selectedMeasurements: [],

                selectedAverage: 10,
                averageOptions: [
                    {value: 1, text: '1 Seconds'},
                    {value: 5, text: '5 Seconds'},
                    {value: 10, text: '10 Seconds'},
                    {value: 20, text: '20 Seconds'},
                    {value: 30, text: '30 Seconds'},
                    {value: 60, text: '60 Seconds'},
                ],
            }
        },
        computed: {
            ...mapGetters({
                measurementDataLoading: 'measurement/isLoading',
                measurementData: 'measurement/current',
                measurementAverageInterval: 'measurement/averageInterval',
                measurementAvailableMeasurements: 'measurement/availableMeasurements',
                measurementSelectedMeasurements: 'measurement/selectedMeasurements',
            }),
        },
        methods: {
            ...mapActions({

                changeAverageInterval: 'measurement/changeAverageInterval',
                changeSelectedMeasurements: 'measurement/changeSelectedMeasurements',
            }),

            refreshAverageInterval: function() {
                let value = this.measurementAverageInterval;
                if(value && this.selectedAverage !== value) {
                    this.selectedAverage = value;
                }
            },
            refreshSelectedMeasurements: function() {
                let value = this.measurementSelectedMeasurements;
                if(value && this.selectedMeasurements !== value) {
                    this.selectedMeasurements = value;
                }
            },

        },
        created() {
            this.refreshAverageInterval();
            this.refreshSelectedMeasurements();
        },
        watch: {
            measurementAverageInterval: {
                handler: function() {
                    this.refreshAverageInterval();
                }
            },

            measurementSelectedMeasurements: {
                handler: function() {
                    this.refreshSelectedMeasurements();
                }
            },

            selectedAverage: {
                handler: function(newValue) {
                    if(newValue && this.measurementAverageInterval !== newValue) {
                        this.changeAverageInterval(newValue);
                    }
                }
            },
            selectedMeasurements: {
                handler: function(newValue) {
                    if(newValue && this.measurementSelectedMeasurements !== newValue) {
                        this.changeSelectedMeasurements(newValue);
                    }
                }
            },

        }
    }
</script>

<style scoped>


.control-container {
  background-color: #f2f2f2;
  padding: 8px;
  border-radius: 6px;
}

</style>